var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "redeemInvite", tag: "section" }
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _vm.classLearner
            ? _c(
                "shortcode-generator",
                {
                  staticClass: "fixedwidth",
                  attrs: {
                    action: "joinClass",
                    title: _vm.$t("joinClass.title"),
                    "invite-code": _vm.$route.query.inviteCode
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("joinClass.subtitle-with-organisation", [
                          _vm.classLearner.class.organisation
                        ])
                      )
                    )
                  ]),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("joinClass.instructions"))
                    }
                  }),
                  _c("br"),
                  _vm.showUpdateWarning
                    ? _c("p", [
                        _c("em", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("joinClass.version-warning")) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("p", [
                    _c("a", { attrs: { target: "_blank", href: _vm.link } }, [
                      _vm._v(_vm._s(_vm.$t("joinClass.help-link")))
                    ])
                  ])
                ]
              )
            : _vm._e(),
          !_vm.busy && !_vm.classLearner
            ? _c(
                "v-card",
                { staticClass: "fixedwidth" },
                [
                  _c("v-card-title", [_vm._v("Error!")]),
                  _c("v-card-text", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("joinClass.error-not-found"))
                      }
                    })
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }